import HeroSection from "./components/HeroSection";
import EmpathySection from "./components/EmpathySection";
import ThreeHurdlesSection from "./components/ThreeHurdlesSection";
import StrengthsSection from "./components/StrengthsSection";
import CoursesSection from "./components/CoursesSection";
import BenefitsSection from "./components/BenefitsSection";
import InstructorSection from "./components/InstructorSection";
import FAQSection from "./components/FAQSection";
import AccessSection from "./components/AccessSection";
import FinalCTASection from "./components/FinalCTASection";
import Footer from "./components/Footer";
import { useState, useEffect } from "react";

declare global {
  interface Window {
    fbq: (action: string, event: string) => void;
  }
}

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleTrialClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  };

  const handleLineClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-white shadow-md" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-3">
              <img 
                src="https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/d2be48817a964cd50d93dca55c707411.png" 
                alt="Size Music School Logo" 
                className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
              />
              <span className={`text-base sm:text-xl font-bold ${isScrolled ? "text-gray-900" : "text-white"}`}>
                Size Music School
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-6">
              <a
                href="#empathy"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                スクールについて
              </a>
              <a
                href="#strengths"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                コース
              </a>
              <a
                href="#instructor"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                講師
              </a>
              <a
                href="#courses"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                料金
              </a>
              <a
                href="#faq"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                よくある質問
              </a>
              <a
                href="#access"
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-gray-900 hover:text-orange-500"
                    : "text-white hover:text-orange-300"
                }`}
              >
                アクセス
              </a>
              <a
                href="#trial-form"
                onClick={handleTrialClick}
                className={`whitespace-nowrap text-sm font-bold px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  isScrolled
                    ? "bg-orange-500 text-white hover:bg-orange-600 shadow-md"
                    : "bg-white text-orange-500 hover:bg-orange-50 shadow-lg"
                }`}
              >
                無料体験レッスン
              </a>
              <a
                href="#line-contact"
                onClick={handleLineClick}
                className={`whitespace-nowrap text-sm font-bold px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  isScrolled
                    ? "bg-green-500 text-white hover:bg-green-600 shadow-md"
                    : "bg-green-500 text-white hover:bg-green-600 shadow-lg"
                }`}
              >
                LINEで相談
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
                isScrolled ? "text-gray-900" : "text-white"
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 space-y-2 bg-white rounded-lg shadow-lg px-4 py-4">
              <a
                href="#empathy"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                スクールについて
              </a>
              <a
                href="#strengths"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                コース
              </a>
              <a
                href="#instructor"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                講師
              </a>
              <a
                href="#courses"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                料金
              </a>
              <a
                href="#faq"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                よくある質問
              </a>
              <a
                href="#access"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm font-semibold text-gray-900 hover:text-orange-500 hover:bg-orange-50 py-3 px-3 rounded-lg transition-colors cursor-pointer"
              >
                アクセス
              </a>
              <div className="pt-2 space-y-2">
                <a
                  href="#trial-form"
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleTrialClick();
                  }}
                  className="block text-center bg-orange-500 text-white font-bold px-5 py-3 rounded-full hover:bg-orange-600 shadow-md transition-all cursor-pointer"
                >
                  無料体験レッスン
                </a>
                <a
                  href="#line-contact"
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleLineClick();
                  }}
                  className="block text-center bg-green-500 text-white font-bold px-5 py-3 rounded-full hover:bg-green-600 shadow-md transition-all cursor-pointer"
                >
                  LINEで相談
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      <HeroSection />
      <EmpathySection />
      <ThreeHurdlesSection />
      <StrengthsSection />
      <CoursesSection />
      <BenefitsSection />
      <InstructorSection />
      <FAQSection />
      <AccessSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
